import * as React from "react";
import { tv, VariantProps } from "tailwind-variants";
import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";
import { ErrorIcon } from "@repo/ui-parkmobile/icons/ErrorIcon";

const textareaContainer = tv({
  base: "uipm:relative uipm:w-full",
});

export const textarea = tv({
  base: cn(
    "uipm:w-full uipm:rounded-xl",
    "uipm:px-4 uipm:py-4 uipm:min-h-[120px]",
    "uipm:text-base uipm:leading-[24px]",
    "uipm:text-[var(--typography-colors-text-body)] uipm:placeholder:text-[var(--typography-colors-text-faded)]",
    "uipm:border-2 uipm:border-transparent uipm:transition-colors",
    "uipm:focus-visible:outline-none uipm:focus-visible:border-[var(--color-color-light)]",
    "uipm:focus:border-[var(--color-color-light)] uipm:active:border-[var(--color-color-light)]",
    "uipm:font-['Inter']",
    "uipm:resize-vertical",
  ),
  variants: {
    state: {
      default: "",
      error:
        "uipm:border-[var(--color-color-danger)] uipm:pr-12 uipm:text-[var(--color-color-danger)]",
      disabled: "uipm:opacity-50 uipm:cursor-not-allowed",
    },
    background: {
      default: "uipm:form-hover",
      white: "uipm:bg-white",
    },
  },
  defaultVariants: {
    state: "default",
    background: "default",
  },
});

export type TextareaProps = VariantProps<typeof textarea> &
  ComponentProps<"textarea"> & {
    containerClassName?: string;
  };

export function Textarea({
  className,
  containerClassName,
  state,
  background,
  disabled,
  ...props
}: TextareaProps) {
  const textareaState = disabled ? "disabled" : state;
  const showErrorIcon = state === "error";

  return (
    <div className={cn(textareaContainer(), containerClassName)}>
      <textarea
        disabled={disabled}
        {...props}
        className={cn(
          textarea({ state: textareaState, background }),
          className,
        )}
      />
      {showErrorIcon && (
        <div className="uipm:absolute uipm:right-4 uipm:top-4 uipm:pointer-events-none">
          <ErrorIcon />
        </div>
      )}
    </div>
  );
}
